import Chart from 'chart.js/auto';

class PressureTemperatureTool {
    constructor() {
        this.$ = jQuery;
        this.data = [];
        this.init();
    }

    async init() {

        const toolContainer = document.querySelector(".temperature-pressure-container");
        if (!toolContainer) {
            return;
        }

        console.log("PressureTemperatureTool initialized");

        await this.loadData();
        this.populateMaterialDropdown();
        this.setupListeners();

        const chartCanvas = document.getElementById("tempPressureChart");
        if (chartCanvas) {
            this.initChart();
        } else {
            console.warn("Chart-element saknas, initieras ej.");
        }
    }
    async loadData() {
        try {
            const response = await fetch('/wp-content/themes/gpa/assets/src/json-tools/mopData20250522.json');
            this.data = await response.json();
            console.log('Data loaded:', this.data);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    }

    populateMaterialDropdown() {
        const materialDropdown = document.querySelector("#gpa-material");
        const mopInput = document.querySelector("#gpa-mop-input"); // Hämta MOP-fältet
        if (!materialDropdown || !mopInput) return;

        materialDropdown.innerHTML = "";

        const defaultOption = document.createElement("option");
        defaultOption.value = "";
        defaultOption.textContent = "Material";
        defaultOption.disabled = true;
        defaultOption.selected = true;
        materialDropdown.appendChild(defaultOption);

        // Fyll materialdropdownen dynamiskt från JSON-datan
        const materials = [...new Set(this.data.map(item => item.material))]; // Unika material
        materials.forEach(material => {
            const option = document.createElement("option");
            option.value = material;
            option.textContent = material.toUpperCase();
            materialDropdown.appendChild(option);
        });

        materialDropdown.addEventListener("change", (event) => {
            this.selectedMaterial = event.target.value;
            this.populateTemperatureDropdown(this.selectedMaterial);
            this.populateSDRDropdown(this.selectedMaterial);

            mopInput.classList.remove("result-present");
            mopInput.value = "";

            if (this.chart) {
                this.chart.data.labels = [];
                this.chart.data.datasets = [];
                this.chart.update();
            }
        });
    }


    populateTemperatureDropdown(selectedMaterial) {
        const temperatureDropdown = document.querySelector("#gpa-temperature");
        const mopInput = document.querySelector("#gpa-mop-input");
        if (!temperatureDropdown || !mopInput) return;

        // Spara nuvarande MOP-värde om det finns
        const previousMOP = mopInput.value.trim();
        console.log(previousMOP);

        temperatureDropdown.innerHTML = "";

        // Lägg till standardalternativ
        const defaultOption = document.createElement("option");
        defaultOption.value = "";
        defaultOption.textContent = "Välj °C";
        defaultOption.disabled = true;
        defaultOption.selected = true;
        temperatureDropdown.appendChild(defaultOption);


        const filteredData = this.data.filter((item) => item.material === selectedMaterial);

        // Hitta unika temperaturer och sortera dem
        let uniqueTemperatures = [
            ...new Set(filteredData.map((item) => parseFloat(item.temperature)))
        ].sort((a, b) => a - b);


        // Lägg till temperaturalternativ i dropdown
        uniqueTemperatures.forEach((temp) => {
            const option = document.createElement("option");
            option.value = temp;
            option.textContent = `${temp} °C`;
            temperatureDropdown.appendChild(option);
        });

        // Eventlistener för temperaturval
        temperatureDropdown.addEventListener("change", (event) => {
            const selectedTemperature = event.target.value;
            this.populateOperatingTime(selectedMaterial, selectedTemperature);

            const selectedCalc = document.querySelector("#gpa-calc").value;
            if (selectedCalc === "mop") {
                this.updateMOP();
            } else if (selectedCalc === "sdr") {
                this.calculateSDR();
            }
        });
    }



    populateSDRDropdown(selectedMaterial) {
        const sdrDropdown = document.querySelector("#gpa-sdr");
        if (!sdrDropdown) return;

        sdrDropdown.innerHTML = "";

        const defaultOption = document.createElement("option");
        defaultOption.value = "";
        defaultOption.textContent = "SDR";
        defaultOption.disabled = true;
        defaultOption.selected = true;
        sdrDropdown.appendChild(defaultOption);

        // Filtrera SDR-värden baserat på valt material
        const sdrValues = [...new Set(
            this.data
                .filter(item => item.material === selectedMaterial)
                .map(item => item.sdr)
        )].sort((a, b) => a - b);

        sdrValues.forEach(sdr => {
            const option = document.createElement("option");
            option.value = sdr;
            option.textContent = sdr;
            sdrDropdown.appendChild(option);
        });
    }

    populateOperatingTime(selectedMaterial, selectedTemperature) {
        const operatingTimeDropdown = document.querySelector("#gpa-driftstid");
        if (!operatingTimeDropdown) return;

        const previouslySelectedTime = operatingTimeDropdown.value;

        const filteredData = this.data.filter(
            (item) => item.material === selectedMaterial && item.temperature === selectedTemperature
        );

        let uniqueOperatingTimes = [
            ...new Set(filteredData.map((item) => item["operatingtime-year"]))
        ].sort((a, b) => a - b);

        // Filtrera bort 50 år om kemapplikation är aktiv och vi beräknar SDR eller MOP
        const chemicalCheckbox = document.querySelector("#chemical-application");
        const calcDropdown = document.querySelector("#gpa-calc");
        
        if (chemicalCheckbox?.checked && calcDropdown?.value && 
            (calcDropdown.value === "sdr" || calcDropdown.value === "mop")) {
            uniqueOperatingTimes = uniqueOperatingTimes.filter(time => time !== "50");
        }

        let isPreviousValid = uniqueOperatingTimes.includes(previouslySelectedTime);

        const newSelectedTime = isPreviousValid ? previouslySelectedTime : (uniqueOperatingTimes[0] || "");

        if (JSON.stringify(uniqueOperatingTimes) !== JSON.stringify([...operatingTimeDropdown.options].map(o => o.value))) {
            operatingTimeDropdown.innerHTML = "";

            const defaultOption = document.createElement("option");
            defaultOption.value = "";
            defaultOption.textContent = "Välj driftstid (år)";
            defaultOption.disabled = true;
            defaultOption.selected = true;
            operatingTimeDropdown.appendChild(defaultOption);


            uniqueOperatingTimes.forEach((time) => {
                const option = document.createElement("option");
                option.value = time;
                option.dataset.hours = filteredData.find((item) => item["operatingtime-year"] === time)["operatingtime-hr"];
                option.textContent = `${time} år`;
                operatingTimeDropdown.appendChild(option);
            });
        }

        if (newSelectedTime) {
            operatingTimeDropdown.value = newSelectedTime;
        }
    }

    setupListeners() {
        const calcDropdown = document.querySelector("#gpa-calc");
        const materialDropdown = document.querySelector("#gpa-material");
        const temperatureDropdown = document.querySelector("#gpa-temperature");
        const sdrDropdown = document.querySelector("#gpa-sdr");
        const mopInput = document.querySelector("#gpa-mop-input");
        const installationAboveGroundCheckbox = document.querySelector("#installation-above-ground");
        const chemicalCheckbox = document.querySelector("#chemical-application");
        const operatingTimeDropdown = document.querySelector("#gpa-driftstid");


        if (!calcDropdown || !materialDropdown || !temperatureDropdown || !sdrDropdown || !mopInput || !installationAboveGroundCheckbox || !chemicalCheckbox || !operatingTimeDropdown) return;

        calcDropdown.addEventListener("change", (event) => {
            this.toggleFields(event.target.value);
            mopInput.classList.remove("result-present");
            
            // Uppdatera driftstid-dropdown när beräkningsmetod ändras
            if (this.selectedMaterial) {
                const selectedTemperature = document.querySelector("#gpa-temperature").value;
                if (selectedTemperature) {
                    this.populateOperatingTime(this.selectedMaterial, selectedTemperature);
                }
            }
        });
        operatingTimeDropdown.addEventListener("change", () => {
            const selectedCalc = document.querySelector("#gpa-calc").value;
            if (selectedCalc === "mop") {
                this.updateMOP();
            } else if (selectedCalc === "sdr") {
                this.calculateSDR();
            }
        });
        materialDropdown.addEventListener("change", () => this.updateMOP());
        temperatureDropdown.addEventListener("change", () => this.updateMOP());
        sdrDropdown.addEventListener("change", () => {
            const selectedCalc = document.querySelector("#gpa-calc").value;
            if (selectedCalc === "mop") {
                this.updateMOP();
            } else if (selectedCalc === "sdr") {

            } else if (selectedCalc === "operatingtime") {
                this.calculateOperatingTime();
            }
        });

        installationAboveGroundCheckbox.addEventListener("change", () => {
            const selectedCalc = document.querySelector("#gpa-calc").value;
            if (selectedCalc === "mop") {
                this.updateMOP();
            } else if (selectedCalc === "sdr") {
                this.calculateSDR();
            } else if (selectedCalc === "operatingtime") {
                this.calculateOperatingTime();
            }
        });

        chemicalCheckbox.addEventListener("change", () => {
            console.log("Kemapplikation checkbox ändrad:", chemicalCheckbox.checked);

            // Uppdatera driftstid-dropdown när kemapplikation ändras
            if (this.selectedMaterial) {
                const selectedTemperature = document.querySelector("#gpa-temperature").value;
                if (selectedTemperature) {
                    this.populateOperatingTime(this.selectedMaterial, selectedTemperature);
                }
            }

            const selectedCalc = document.querySelector("#gpa-calc").value;
            console.log('selected calc:', selectedCalc);
            if (selectedCalc === "mop") {
                this.updateMOP();
            } else if (selectedCalc === "sdr") {
                this.calculateSDR();
            } else if (selectedCalc === "operatingtime") {
                this.calculateOperatingTime();
            }
        });

        mopInput.addEventListener("input", () => {
            const selectedCalc = document.querySelector("#gpa-calc").value;

            if (selectedCalc === "sdr") {
                this.calculateSDR();
            } else if (selectedCalc === "operatingtime") {
                this.calculateOperatingTime();
            }
        });
    }




    toggleFields(selectedCalc) {
        const mopField = document.querySelector("#gpa-mop-input");
        const driftstidField = document.querySelector("#gpa-driftstid");
        const driftstidResult = document.querySelector("#gpa-driftstid-result");
        const sdrField = document.querySelector("#gpa-sdr");
        const installationAboveGroundContainer = document.querySelector("#installation-above-ground-container");
        const installationAboveGroundCheckbox = document.querySelector("#installation-above-ground");
        const chemicalCheckbox = document.querySelector("#chemical-application");
        const chartContainer = document.querySelector("#tempPressureChart");
        let sdrWarning = document.querySelector("#sdr-warning");
        let operatingTimeWarning = document.querySelector("#driftstid-warning");

        if (!mopField || !driftstidField || !sdrField || !installationAboveGroundContainer) return;

        //Töm fälten när beräkningsmetod ändras
        mopField.classList.remove("result-present");
        sdrField.classList.remove("result-present");
        driftstidField.classList.remove("result-present");

        if (this.lastSelectedCalc !== selectedCalc) {
            mopField.value = "";
            driftstidField.value = "";
            sdrField.value = "";

            driftstidResult.value = "";
            driftstidResult.classList.remove("result-present");

            //checka ur checkboxar
            installationAboveGroundCheckbox.checked = false;
            chemicalCheckbox.checked = false;

            sdrWarning.textContent = "";
            operatingTimeWarning.textContent = "";
            // Töm diagrammet när användaren byter beräkningsmetod
            if (this.chart) {
                this.chart.data.labels = [];
                this.chart.data.datasets = [];
                this.chart.update();
            }
        }

        driftstidField.style.display = "none";
        driftstidResult.style.display = "none";
        installationAboveGroundContainer.style.display = "none";

        if (selectedCalc === "sdr") {
            driftstidField.style.display = "block";
            chartContainer.style.display = "block";
        } else if (selectedCalc === "mop") {
            driftstidField.style.display = "block";
            chartContainer.style.display = "block";
        } else if (selectedCalc === "operatingtime") {
            driftstidResult.style.display = "block";
            chartContainer.style.display = "none";
        } else {
            driftstidField.style.display = "block";
            chartContainer.style.display = "block";
        }

        switch (selectedCalc) {
            case "mop":
                mopField.disabled = true;
                driftstidField.disabled = false;
                sdrField.disabled = false;
                break;
            case "operatingtime":
                driftstidField.disabled = true;
                mopField.disabled = false;
                sdrField.disabled = false;
                break;
            case "sdr":
                sdrField.disabled = true;
                mopField.disabled = false;
                driftstidField.disabled = false;
                this.populateSDRDropdown(this.selectedMaterial);
                break;
            default:
                mopField.disabled = false;
                driftstidField.disabled = false;
                sdrField.disabled = false;
                break;
        }

        this.lastSelectedCalc = selectedCalc;
    }



    updateMOP() {

        const calcDropdown = document.querySelector("#gpa-calc");
        const mopInput = document.querySelector("#gpa-mop-input");
        const installationAboveGroundCheckbox = document.querySelector("#installation-above-ground");
        const chemicalCheckbox = document.querySelector("#chemical-application");
        const selectedMaterial = this.selectedMaterial;
        const selectedTemperature = document.querySelector("#gpa-temperature").value;
        const selectedOperatingTime = document.querySelector("#gpa-driftstid").value;

        // Om inget SDR är valt, rita upp alla linjer för de valda parametrarna
        const sdrElem = document.querySelector("#gpa-sdr");
        if (!sdrElem.value) {
            mopInput.value = "";
            mopInput.classList.remove("result-present");
            this.updateChart(null);
            return;
        }
        const selectedSDR = parseFloat(sdrElem.value);

        if (!calcDropdown || !mopInput || !selectedMaterial || !selectedTemperature || !selectedOperatingTime) return;
        if (calcDropdown.value !== "mop") {
            return;
        }

        console.log("Calculating MOP...");

        let matchingData = this.data.find(item =>
            item.material === selectedMaterial &&
            item.temperature === selectedTemperature &&
            item.sdr === selectedSDR.toString() &&
            item["operatingtime-year"] === selectedOperatingTime.toString()
        );

        if (!matchingData) {

            mopInput.value = "";
            console.warn("Ingen matchande data hittades för vald driftstid.");
            mopInput.classList.remove("result-present");

            this.updateChart();
            return;
        }

        let mopValue;

        if (!chemicalCheckbox.checked) {
            console.log("Använder standardvärde från tabellen");
            mopValue = parseFloat(matchingData.mop);

            if (installationAboveGroundCheckbox.checked) {
                mopValue *= 0.8;
                console.log("Installation ovan mark aktiv - MOP justerat till:", mopValue);
            }

            mopInput.value = mopValue.toFixed(1);
            console.log("Standardvärde från tabellen används:", mopValue);

        } else {
            // Om kemapplikation är AKTIV – leta upp raden med C = 2
            let chemicalData = this.data.find(item =>
                item.material === selectedMaterial &&
                item.temperature === selectedTemperature &&
                item.sdr === selectedSDR.toString() &&
                item["operatingtime-year"] === selectedOperatingTime.toString() &&
                item.c === "2"
            );

            if (chemicalData) {
                mopValue = parseFloat(chemicalData.mop);

                if (installationAboveGroundCheckbox.checked) {
                    mopValue *= 0.8;
                    console.log("Installation ovan mark aktiv - MOP justerat till:", mopValue);
                }

                mopInput.value = mopValue.toFixed(1);
                console.log("MOP hämtad direkt från tabellen där C = 2:", mopValue);

            } else {
                // Om vi inte hittar data med C = 2, fall tillbaka till beräkning
                const MRS = parseFloat(matchingData.mrs);
                const c = selectedMaterial.toLowerCase() === "pvc"
                    ? parseFloat(matchingData.c)
                    : 2.0;

                if (isNaN(MRS) || selectedSDR <= 1) {
                    console.warn("Ogiltiga värden för beräkning");
                    this.updateChart();
                    return;
                }

                mopValue = (20 * MRS) / (c * (selectedSDR - 1));
                console.log('uträkning av MOP:', mopValue);
                console.log('alla värden', 'MRS ', MRS, c, selectedSDR);
                if (installationAboveGroundCheckbox.checked) {
                    mopValue *= 0.8;
                    console.log("Installation ovan mark aktiv - nytt PB-värde:", mopValue);
                }

                mopInput.value = mopValue.toFixed(1);
                console.log("Ny MOP beräknad med kemapplikation:", mopValue);
            }
        }
        mopInput.classList.add("result-present");

        this.updateChart(mopValue);
    }

    calculateSDR() {
        const calcDropdown = document.querySelector("#gpa-calc");
        if (calcDropdown.value !== "sdr") return;
        const mopInput = document.querySelector("#gpa-mop-input");
        const sdrDropdown = document.querySelector("#gpa-sdr");
        if (!mopInput || !sdrDropdown) return;

        let sdrWarning = document.querySelector("#sdr-warning");
        const selectedMaterial = this.selectedMaterial;
        const selectedTemperature = document.querySelector("#gpa-temperature").value;
        const selectedOperatingTime = document.querySelector("#gpa-driftstid").value;
        const chemicalCheckbox = document.querySelector("#chemical-application");
        const installationAboveGroundCheckbox = document.querySelector("#installation-above-ground");

        const isAboveGround = !!installationAboveGroundCheckbox?.checked;

        if (!selectedMaterial || !selectedTemperature || !selectedOperatingTime) return;

        console.log("Calculating SDR...");

        //  Om MOP-fältet är tomt => töm SDR, rensa eventuella varningar och rita diagram utan highlight
        if (mopInput.value.trim() === "") {
            sdrDropdown.value = "";
            sdrDropdown.classList.remove("result-present");
            if (sdrWarning) sdrWarning.textContent = "";
            mopInput.classList.remove("result-present");
            console.log("MOP är tomt - ingen SDR och ingen highlight");
            this.updateChart(null);
            return;
        }

        //Om MOP inte är tomt, hämta numeriskt värde
        let MOP = parseFloat(mopInput.value.replace(",", "."));
        if (isNaN(MOP) || MOP <= 0) {
            console.warn("Ogiltigt MOP-värde");
            return;
        }

        // Hitta matchande data för att få reduceringsfaktor
        const matchingData = this.data.find(item =>
            item.material === selectedMaterial &&
            item.temperature === selectedTemperature &&
            item["operatingtime-year"] === selectedOperatingTime
        );
        console.log("Matching Data:", matchingData);

        //    Om material är PVC ignoreras kemapplikation (c = 2.5)
        const validSDRs = [...new Set(this.data
            .filter(item =>
                item.material === selectedMaterial &&
                item.temperature === selectedTemperature &&
                item["operatingtime-year"] === selectedOperatingTime &&
                (selectedMaterial.toLowerCase() === "pvc" || (!chemicalCheckbox.checked || item.c === "2"))
            )
            .map(item => ({
                sdr: parseFloat(item.sdr),
                // Ändring: multiplicera tabellens MOP med 0.8 om installation ovan mark
                mop: isAboveGround ? parseFloat(item.mop) * 0.8 : parseFloat(item.mop)
            }))
        )].sort((a, b) => a.sdr - b.sdr);

        console.log("Valid SDRs:", validSDRs);

        if (validSDRs.length === 0) {
            console.warn("Inga giltiga SDR-värden hittades");
            return;
        }


        const minMOP = Math.min(...validSDRs.map(item => item.mop));
        const maxMOP = Math.max(...validSDRs.map(item => item.mop));

        if (MOP > maxMOP) {
            sdrDropdown.value = "";
            if (!sdrWarning) {
                sdrWarning = document.createElement("span");
                sdrWarning.id = "sdr-warning";
                sdrDropdown.parentNode.appendChild(sdrWarning);
            }
            sdrWarning.textContent = "För högt tryck!";
            sdrWarning.style.color = "red";
            console.warn("MOP överstiger maxvärdet:", maxMOP);

            this.updateChart(null);
            return;
        } else {
            if (sdrWarning) sdrWarning.textContent = "";
        }

        let finalMOP = MOP; // Using the adjusted MOP value
        if (MOP < minMOP) {
            const highestSDR = validSDRs[validSDRs.length - 1].sdr;
            sdrDropdown.value = highestSDR;
            console.warn("MOP understiger minvärdet, väljer högsta SDR:", highestSDR);
        } else {
            const MRS = this.data.find(item =>
                item.material === selectedMaterial &&
                item.temperature === selectedTemperature &&
                item["operatingtime-year"] === selectedOperatingTime
            )?.mrs;

            if (!MRS) {
                console.warn("MRS hittades inte i data");
                return;
            }

            // Bestäm c: För PVC alltid 2.5, annars om kem → 2.0, annars hämta c från tabellen
            const c = selectedMaterial.toLowerCase() === "pvc"
                ? 2.5
                : (chemicalCheckbox.checked ? 2.0 : parseFloat(this.data.find(item =>
                    item.material === selectedMaterial &&
                    item.temperature === selectedTemperature &&
                    item["operatingtime-year"] === selectedOperatingTime
                )?.c));

            if (isNaN(c)) {
                console.warn("C-värdet är ogiltigt");
                return;
            }

            console.log('C-värde:', c);
            const sdrValue = (20 * MRS) / (c * (MOP * matchingData.reducfactor)) + 1;

            // Använd reduce med initialvärde så att nearestSDR alltid blir ett nummer
            const nearestSDRValue = validSDRs.reduce(
                (prev, curr) => (curr.sdr <= sdrValue ? curr.sdr : prev),
                validSDRs[0].sdr
            );

            console.log("Beräknat SDR:", sdrValue, "Närmaste SDR:", nearestSDRValue);
            sdrDropdown.value = nearestSDRValue;
        }

        sdrDropdown.classList.add("result-present");

        this.updateChart(finalMOP);
    }
    calculateOperatingTime() {

        const mopInput = document.querySelector("#gpa-mop-input");
        const sdrDropdown = document.querySelector("#gpa-sdr");
        const driftstidField = document.querySelector("#gpa-driftstid-result");
        const driftstidWarning = document.querySelector("#driftstid-warning");

        if (!mopInput || !sdrDropdown || !driftstidField) return;

        const selectedMaterial = this.selectedMaterial;
        const selectedTemperature = document.querySelector("#gpa-temperature").value;
        const selectedSDR = parseFloat(sdrDropdown.value);

        if (!selectedMaterial || !selectedTemperature || isNaN(selectedSDR)) return;
        console.log("Calculating Operating Time...");

        // Hämta matchande rad från JSON-datan
        const matchingData = this.data.find(item =>
            item.material === selectedMaterial &&
            item.temperature === selectedTemperature &&
            item.sdr === selectedSDR.toString()
        );
        console.log("Matching Data:", matchingData);
        if (!matchingData) {
            console.warn("Ingen matchande data hittades");
            return;
        }

        // Hämta värden från tabellen
        const factor = parseFloat(matchingData.factor);

        const chemicalCheckbox = document.querySelector("#chemical-application");

        // Använd c = 2.0 om kemapplikation är aktiverad, annars hämta från tabellen
        const c = chemicalCheckbox.checked ? 2.0 : parseFloat(matchingData.c);

        const exponent = parseFloat(matchingData.exponent);
        const lifespan = parseFloat(matchingData.lifespan);
        console.log('c =', c);
        console.log("MOP från input (innan parseFloat):", mopInput.value);
        let MOP = parseFloat(mopInput.value.replace(",", "."));
        console.log("MOP efter parseFloat:", MOP);

        //ge mop ett nytt värde. ta mop * matchingData.reducfactor
        const reductionFactor = matchingData.reducfactor;
        console.log("Reduceringsfaktor:", reductionFactor);
        console.log('mop före reduceringsfaktor:', MOP);
        if (reductionFactor) {
            MOP = MOP * reductionFactor;
            console.log("MOP efter reduceringsfaktor:", MOP);
        } else {
            console.warn("Ingen reduceringsfaktor hittades i datan");
        }


        if (isNaN(factor) || isNaN(c) || isNaN(exponent) || isNaN(MOP) || MOP <= 0) {
            console.warn("Ogiltiga värden för beräkning");
            return;
        }

        console.log(`Faktor: ${factor}, C: ${c}, Exponent: ${exponent}, MOP: ${MOP}, SDR: ${selectedSDR}`);


        const sdrMinusOne = selectedSDR - 1;
        const denominator = MOP * c * sdrMinusOne;
        const numerator = 20 * factor;

        console.log(`sdrMinusOne: ${sdrMinusOne}, denominator: ${denominator}, numerator: ${numerator}`);

        // Kontrollera att vi inte dividerar med 0
        if (denominator <= 0) {
            console.warn("Denominator är 0 eller negativ, kan ej räkna ut driftstid.");
            driftstidField.value = "Ogiltigt värde";
            return;
        }

        const baseValue = numerator / denominator;
        console.log(`baseValue: ${baseValue}`);

        // Kontrollera att baseValue inte är negativt eller 0
        if (baseValue <= 0) {
            console.warn("BaseValue är 0 eller negativt, kan ej räkna ut driftstid.");
            driftstidField.value = "Ogiltigt värde";
            return;
        }
        const exponentResult = Math.pow(baseValue, 1 / exponent);
        let operatingTime = exponentResult / 8760; // Konvertera till år

        console.log(`Exponent Result: ${exponentResult}, Operating Time (innan avrundning): ${operatingTime}`);

        if (operatingTime > lifespan) {
            console.warn(`Driftstiden översteg lifespan (${lifespan} år), värdet har begränsats.`);
            operatingTime = lifespan;
        }


        let finalOperatingTime = Math.floor(operatingTime);
        if (finalOperatingTime < 0) finalOperatingTime = 0;
        // Bestämd max-gräns: 25 år vid kemapplikation, annars 50 år
        const maxYears = chemicalCheckbox.checked ? 25 : 50;
        if (finalOperatingTime > maxYears) finalOperatingTime = maxYears;

        console.log("Beräknad driftstid (efter avrundning):", finalOperatingTime);

        driftstidField.value = `${finalOperatingTime} år`;
        if (driftstidField.value !== "") {
            driftstidField.classList.add("result-present");
        } else {
            driftstidField.classList.remove("result-present");
        }

        // Visa varning om driftstiden är 0
        if (finalOperatingTime === 0) {
            if (driftstidWarning) {
                driftstidWarning.textContent = "För högt tryck!";
                driftstidWarning.style.color = "red";
            }
        } else {
            if (driftstidWarning) {
                driftstidWarning.textContent = "";
            }
        }

        // Om mopInput är tom så töm driftstid-fältet
        if (mopInput.value === "") {
            driftstidField.value = "";
        }
    }

    updateChart(finalMOP = null) {
        console.log("Updating chart...");

        const selectedMaterial = this.selectedMaterial; // Sätts i populateMaterialDropdown()
        const selectedTemperature = document.querySelector("#gpa-temperature")?.value;
        const selectedOperatingTime = document.querySelector("#gpa-driftstid")?.value;
        const selectedSDR = document.querySelector("#gpa-sdr")?.value;
        const chemicalCheckbox = document.querySelector("#chemical-application");
        const installationCheckbox = document.querySelector("#installation-above-ground");


        if (!selectedMaterial || !selectedOperatingTime || !selectedTemperature) {
            console.warn("Saknar material, driftstid eller temperatur – kan ej rita diagrammet.");
            return;
        }

        //  Kolla om installation ovan mark är aktiv (0.8‑skalning)
        const isAboveGround = !!installationCheckbox?.checked;

        // Hämta alla unika SDR‑värden för valt material & driftstid (temperatur ignoreras)
        const allSdrs = [...new Set(
            this.data
                .filter(item =>
                    item.material.toLowerCase() === selectedMaterial.toLowerCase() &&
                    item["operatingtime-year"] === selectedOperatingTime
                )
                .map(item => item.sdr)
        )].sort((a, b) => parseFloat(a) - parseFloat(b));

        if (!allSdrs.length) {
            console.warn("Inga SDR hittades för valda inställningar (material + driftstid).");
            if (this.chart) {
                this.chart.data.labels = [];
                this.chart.data.datasets = [];
                this.chart.update();
            }
            return;
        }

        const nonActiveColors = ["#95c11f", "#fecc3a", "#B32390", "#d64923", "#f09d4b", "#007b92"];
        let nonActiveIndex = 0;
        const activeColor = "#007b92";

        const allDatasets = [];

        // Loop över varje SDR och bygg dataset

        allSdrs.forEach((sdr) => {
            // Filtrera ut all data för detta material, driftstid och SDR (temperatur ignoreras i filtret)
            let relevantData = this.data.filter(item => {
                if (item.material.toLowerCase() !== selectedMaterial.toLowerCase()) return false;
                if (item.sdr !== sdr) return false;
                if (item["operatingtime-year"] !== selectedOperatingTime) return false;
                // c‑värdeslogik:
                if (selectedMaterial.toLowerCase() === "pvc") {
                    return parseFloat(item.c) === 2.5; // PVC: c=2.5 oavsett kemapplikation
                } else {
                    if (chemicalCheckbox.checked) {
                        // Kemapplikation: c ska vara 2.0
                        return parseFloat(item.c) === 2.0;
                    } else {
                        // Icke‑kemapplikation: om PP, använd c < 2, annars standard (t.ex. 1.25)
                        if (selectedMaterial.toLowerCase() === "pp") {
                            return parseFloat(item.c) < 2.0;
                        } else {
                            const defaultC = this.data.find(d =>
                                d.material === selectedMaterial &&
                                d.sdr === sdr &&
                                d["operatingtime-year"] === selectedOperatingTime &&
                                d.temperature === item.temperature
                            )?.c || "1.25";
                            return parseFloat(item.c) === parseFloat(defaultC);
                        }
                    }
                }
            });

            // Sortera relevantData på temperatur (numeriskt)
            relevantData.sort((a, b) => parseFloat(a.temperature) - parseFloat(b.temperature));
            if (!relevantData.length) return;

            console.log("relevantData för SDR =", sdr, relevantData);

            // Bygg x/y‑data: skapa en array med objekt { x: temperatur, y: MOP }

            const dataPoints = [];
            const borderDashStyles = [];
            let usingShortened = false;

            relevantData.forEach(item => {
                const temp = parseFloat(item.temperature);
                let normalMop = parseFloat(item.mop);
                let shortMop = parseFloat(item["mop-shortened-lifespan"]);

                // Skala MOP‑värden med 0.8 om installation ovan mark
                if (isAboveGround && !isNaN(normalMop)) {
                    normalMop *= 0.8;
                }
                if (isAboveGround && !isNaN(shortMop)) {
                    shortMop *= 0.8;
                }

                // Om normalMop finns, använd den
                if (!isNaN(normalMop)) {
                    dataPoints.push({ x: temp, y: normalMop });
                    borderDashStyles.push(usingShortened ? [5, 5] : []);
                }

                else if (!isNaN(shortMop)) {
                    usingShortened = true;
                    dataPoints.push({ x: temp, y: shortMop });
                    borderDashStyles.push([5, 5]);
                }
            });
            if (!dataPoints.length) return;

            const rawName = relevantData[0]?.name?.toUpperCase() ?? `SDR ${sdr}`;
            const itemName = rawName.replace(/SDR(\d)/i, 'SDR $1');

            //  Skapa dataset-objektet för denna SDR

            const isSelected = (sdr === selectedSDR);
            // Använd aktiv färg om vald, annars hämta från nonActiveColors i ordning
            const lineColor = isSelected ? activeColor : nonActiveColors[nonActiveIndex % nonActiveColors.length];
            if (!isSelected) { nonActiveIndex++; }
            const datasetLabel = isSelected
                ? `${itemName} (vald)`
                : itemName;
            const radius = isSelected ? 4 : 1;

            const dataset = {
                label: datasetLabel,
                clip: false,
                data: dataPoints,
                borderColor: lineColor,
                borderWidth: isSelected ? 3 : 1.5,
                backgroundColor: lineColor,
                fill: false,
                pointRadius: radius,
                pointHoverRadius: radius,
                pointBackgroundColor: lineColor,
                pointBorderColor: lineColor,
                segment: {
                    borderDash: ctx => borderDashStyles[ctx.p0DataIndex] || []
                }
            };

            allDatasets.push(dataset);


            //  Om denna SDR är vald och vi har ett finalMOP, lägg in en highlight‑dataset

            if (isSelected && finalMOP !== null && !isNaN(finalMOP)) {
                const highlightDataset = {
                    label: "Aktuell MOP",
                    clip: false,
                    data: [{ x: parseFloat(selectedTemperature), y: finalMOP }],
                    pointStyle: "circle",
                    pointRadius: 8,
                    pointHoverRadius: 10,
                    backgroundColor: "#50bcbd",
                    borderColor: "#50bcbd",
                    showLine: false,
                    order: 999
                };
                allDatasets.push(highlightDataset);
            }
        });


        if (!this.chart) {
            console.warn("this.chart saknas. Har du initierat initChart()?");
            return;
        }

        this.chart.data.labels = [];
        this.chart.data.datasets = allDatasets;
        {
            const sortedX = [...new Set(allDatasets.flatMap(ds => ds.data.map(pt => pt.x)))]
                .sort((a, b) => a - b);
            const dataMin = sortedX[0];
            const dataMax = sortedX[sortedX.length - 1];
            const stepSize = sortedX.length > 1 ? sortedX[1] - sortedX[0] : 1;
            if (this.chart.options.scales && this.chart.options.scales.x) {
                const xScale = this.chart.options.scales.x;
                xScale.min = dataMin;
                xScale.max = dataMax;
                xScale.ticks.stepSize = stepSize;
            }
        }

        this.chart.update();
    }
    initChart() {
        const ctx = document.getElementById('tempPressureChart').getContext('2d');
        this.chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: [],
                datasets: []
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'right',
                    },
                    tooltip: {
                        callbacks: {
                            title: (items) => {
                                const x = items[0].parsed.x;
                                return x + ' °C';
                            },
                            label: (context) => {
                                let label = context.dataset.label || '';
                                if (label) label += ': ';
                                if (context.parsed && context.parsed.y !== undefined) {
                                    label += context.parsed.y + ' bar';
                                }
                                return label;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        type: 'linear',
                        title: {
                            display: true,
                            text: 'Temperatur (°C)'
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Tryck (bar)'
                        }
                    }
                }
            }
        });
    }
}

export default PressureTemperatureTool;
